const BASE = process.env.REACT_APP_API_URL || "https://lightslategrey-mole-360881.hostingersite.com/api";

async function staffFetch(endpoint, options = {}) {
  const token = localStorage.getItem("kkb_token");
  const cfg = {
    headers: {
      "Content-Type": "application/json",
      ...(token ? { Authorization: `Bearer ${token}` } : {}),
    },
    credentials: "include",
    ...options,
  };
  if (cfg.body && typeof cfg.body === "object")
    cfg.body = JSON.stringify(cfg.body);
  const res = await fetch(`${BASE}/staff${endpoint}`, cfg);
  const data = await res.json();
  if (!res.ok) throw new Error(data.message || "Request failed");
  return data;
}

export const sGet = (url, params = {}) => {
  const qs = new URLSearchParams(
    Object.fromEntries(
      Object.entries(params).filter(([, v]) => v !== undefined && v !== ""),
    ),
  ).toString();
  return staffFetch(`${url}${qs ? "?" + qs : ""}`);
};

export const sPost = (url, body) => staffFetch(url, { method: "POST", body }); // ← ADD THIS

export const sPut = (url, body) => staffFetch(url, { method: "PUT", body });
export const sDelete = (url) => staffFetch(url, { method: "DELETE" });
